export const APPLICATION_QUESTION_OPTION_TEMPLATE_MODEL =
  "application-question-option-template";

const applicationQuestionOptionTemplateModel = {
  validResponse: false,
  option: ""
};

export default applicationQuestionOptionTemplateModel;
